export const AUTOMATIC_PLY_COORDINATE_EVIDENCE_METHOD =
  "automatic-ply-coordinate-evidence-v1";
export const PLY_COORDINATE_HEADER_BUDGET_BYTES = 2 * 1024 * 1024;
export const PLY_COORDINATE_HEADER_BUDGET_NAME = "ply_coordinate_header_bytes";
